module.exports = __webpack_public_path__ + "img/iconXiTongChanPinLieBiao.b400c42c.svg";